import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAgenticCoding: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAgenticCoding"><Path d="M18.5 11L19.75 14.25L23 15.5V16.5L19.75 17.75L18.5 21H17.5L16.25 17.75L13 16.5V15.5L16.25 14.25L17.5 11H18.5Z" fill="currentColor"/><Path d="M10 18.75H3V17.25H10V18.75Z" fill="currentColor"/><Path d="M6 12.75H3V11.25H6V12.75Z" fill="currentColor"/><Path d="M13 12.75H8V11.25H13V12.75Z" fill="currentColor"/><Path d="M13 6.75H3V5.25H13V6.75Z" fill="currentColor"/><Path d="M21 6.75H15V5.25H21V6.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAgenticCoding;
